
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  useDisclosure,
  Text,
  Image,
  Input,
  useToast,
  Table,
} from "@chakra-ui/react";
import axios from "axios";
import { useEffect, useState } from "react";
import { ChatState } from "../../Context/ChatProvider";

const ProfileModal = () => {

  

   const { isOpen, onOpen, onClose } = useDisclosure();
   const toast = useToast();
   const {user}=ChatState()

   const [image, setImage] = useState();
  const[picLoading,setPicLoading]=useState(false);
  const [id, setId] = useState(user ? user._id : "");
  const [name, setName] = useState(user ? user.name : "");
  const [dob, setDob] = useState(user ? new Date(user.dob).toLocaleDateString() : "");
  const [pic, setPic] = useState(user ? user.pic : "");
  const [password, setPassword] = useState('');



  const clodeModal = () => {
    setImage();
    setPicLoading(false)
    setPassword('');
    onClose();
  }
  useEffect(()=>{
    if(user.pic!==pic)
    updateUser()
  },[pic])
  const updateUser = async () => {
    if (!name || !dob ) {
      toast({
        title: "Veuillez remplir tous les champs",
        status: "warning",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      setPicLoading(false);
      return;
    }
    setPicLoading(true);

    try {
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${user.token}`,
        },
      };
      await axios.put(
        "/api/user",

        {
          id,
          name,
          dob,
          pic,
          password,
          profile:true
        },
        config
      );

      toast({
        title: "Aktualisiert Erfolgreich",
        status: "success",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      const userUp=JSON.parse(localStorage.getItem("userInfo"))
      userUp.name=name;
      userUp.dob=dob;
      userUp.pic=pic;
      localStorage.setItem("userInfo", JSON.stringify(userUp));
      clodeModal()
    } catch (error) {
      toast({
        title: "Une erreur s'est produite !",
        description: error.response.data.message,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });

    }

  };

  const updateProfileImage = async () => {

    if (image) {

      const fileData = new FormData()
      fileData.append('file', image)

      try {
        const response = await fetch('/api/profiles/upload', {
          method: 'POST',
          body: fileData,

        });

        if (response.ok) {

          const result = await response.json();
          setPic(result.filename);
          
        } else {
          alert('Bild kann nicht hochgeladen werden');
        }
      } catch (error) {
        console.error('Error:', error)
        alert('Beim Hochladen des Bildes ist ein Fehler aufgetreten');
      }

    }
    else{
      updateUser()
    }
   
  }


  const updateProfile=()=>
  {
    updateProfileImage()
   
  }
  
  return (
    <>
      
        <Button variant="ghost" onClick={onOpen}>
          <i className="fa-solid fa-user text-lg"></i></Button>
    
      <Modal size="lg" onClose={onClose} isOpen={isOpen} isCentered>
        <ModalOverlay />
         <ModalContent h="350px">
          <ModalHeader
            fontSize="20px"
            color={'gray.600'}
            d="flex"
            justifyContent="left"
          >
            Persönliche Informationen
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody
            d="flex"
            flexDir="row"
            alignItems="flex-start"
            justifyContent="start"
          >
            <div className="w-1/3 flex flex-col items-center mr-10">
              <Image
                borderRadius="full"
                boxSize="100px"
                src={image ? URL.createObjectURL(image) : pic ? `../../uploads/profiles/${pic}` :'https://icon-library.com/images/anonymous-avatar-icon/anonymous-avatar-icon-25.jpg'}
                alt={user.name}
              />

              <label
                className=" p-1 text-gray-500  font-bold  cursor-pointer">
                <input type="file" accept="image/*" className="hidden" onChange={(e) => setImage(e.target.files[0])} />
                <p className="text-blue-900 font-bold" >Ändern</p>
              </label>

            </div>
            <div className="w-full h-52 flex flex-col justify-between">
             
              <Text
                fontSize={{ base: "18px" }}
                color='gray.600'
                display={'flex'}
                alignItems='center'
                alignContent='space-between'
                justifyContent='space-between'
                w={"full"}
              >
                <span className="font-semibold ">Name : </span> 
                <Input w='50%'  h='8' type="text" value={name}  onChange={(e) => setName(e.target.value)} />
              </Text>
              <Text
                fontSize={{ base: "18px" }}
                color='gray.600'
                display={'flex'}
                alignItems='center'
                alignContent='space-between'
                justifyContent='space-between'
                w={"full"}
              >
                <span className="font-semibold ">Geburtstag :  </span>
                 <Input w='50%'  h='8' type="text" value={dob} onChange={(e) => setDob(e.target.value)}/>
              </Text>
              <Text
                fontSize={{ base: "18px" }}
                color='gray.600'
                display={'flex'}
                alignItems='center'
                alignContent='center'
              >
                <span className="font-semibold mr-3">Nutzername : </span> {user.username}
              </Text>
              <Text
                fontSize={{ base: "18px" }}
                color='gray.600'
                display={'flex'}
                alignItems='center'
                alignContent='space-between'
                justifyContent='space-between'
                w={"full"}

              >
                <span className="font-semibold mr-10">Passwort : </span> 
                <Input w='50%'  h='8' type="text" value={password} onChange={(e) => setPassword(e.target.value)}/>
              </Text>
            </div>

          </ModalBody>
          <ModalFooter>
            <Button colorScheme='blue' mr={3}
              onClick={() => updateProfile()}
              isLoading={picLoading}
            >
              Speichern</Button>
            <Button onClick={() => clodeModal()}>Abbrechen</Button>
          </ModalFooter>
        </ModalContent> 
      </Modal>
    </>
  );
};

export default ProfileModal;
